<template>
<div class="grid raised_item mt-4 mb-2 mx-1 animate_class pl-4 pb-4">


<template v-if="loading">

<div :class="name_area">

<div class="grid">

<div :class="project_info">
<Skeleton  height="2.2rem" class="mb-5 mt-3"></Skeleton>
<hr v-if="!is_narrow">
<Skeleton height="2rem" class="mb-3 mt-3"></Skeleton>
<Skeleton height="2rem" class="mb-3"></Skeleton>
<Skeleton height="2rem" class="mb-3"></Skeleton>
<Skeleton height="2rem" class="mb-2"></Skeleton>
</div>

<div :class="project_button">

<div class="flex align-items-center justify-content-end pr-4" v-if="is_narrow">
<Skeleton width="10rem" height="2.5rem"></Skeleton>
</div>

<div class="flex align-items-center justify-content-start" v-if="!is_narrow">
<Skeleton width="10rem" height="1.7rem"></Skeleton>
</div>


</div>


</div>


</div>

<div :class="line_graph_area">
<Skeleton  height="18rem" class="mt-3"></Skeleton>
</div>
<!-- line chart --> 
<!-- pie chart -->  
<div :class="pie_graph_area">
<Skeleton shape="circle" size="18rem" class="mt-3"></Skeleton>
</div>
<!-- pie chart -->  




</template>

<template v-if="!loading">


<div :class="name_area">

<div class="grid">
<div class="hidden">{{preflang_id}}</div>
<div :class="project_info">
<h3 class="text-purple-500 mb-0" style="min-height:50px">{{projectname}}</h3>
<hr v-if="!is_narrow">
<h4 class="text-primary mb-0">{{$store.state.languages.lang_phrases.baslangic_tarihi}}</h4>
<h4 class="mb-0">{{ $filters.momentFormat( data.project.start_date," DD-MM-YYYY")}}</h4>
<h4 class="text-primary mb-0">{{$store.state.languages.lang_phrases.kayitli_tedarikci}}</h4>
<h4 class="mb-0">{{started+finished}}</h4>

</div>

<div :class="project_button" v-if="show_project_link">

<div class="flex align-items-center justify-content-end pr-4" v-if="is_narrow">
<Button type="button" class="p-button-primary p-button-outlined p-button-sm" icon="pi pi-eye" :label="$store.state.languages.lang_phrases.proje_detaylari" @click="gotoProject" />
</div>

<div class="flex align-items-center justify-content-start" v-if="!is_narrow">
<Button type="button" class="p-button-primary p-button-outlined p-button-sm" icon="pi pi-eye" :label="$store.state.languages.lang_phrases.proje_detaylari" @click="gotoProject" />
</div>


</div>


</div>


</div>




<!--  suppliers -->
<template v-if="data.project_suppliers.length">
<!-- line chart -->	
<div :class="line_graph_area">
<Chart type="line" :data="lineChartData" :options="lineChartOptions" />
</div>
<!-- line chart -->	
<!-- pie chart -->	
<div :class="pie_graph_area">
<Chart type="doughnut" :data="chartData" :options="lightOptions" />	
</div>
<!-- pie chart -->	


</template>
<!--  suppliers -->

<!-- no suppliers -->
<template v-else>
	
</template>
<!-- no suppliers -->






</template>



</div>	
</template>

<script>
import moment from "moment"
export default {

  name: 'ProjectCard',
  props:["project_id","is_narrow","show_project_link"],
  data () {
    return {
            loading:true,
            data:null,
            started:0,
            finished:0,
            total:0,
            lineChartData: {

            labels: [],
                datasets: [
                    {
                        label: this.$store.state.languages.lang_phrases.tamamlanma_araligi,
                        data: [],
                        fill: false,
                        borderColor: '#7e2f8d',
                        tension: .4
                    },
                ]
            },
            lineChartOptions: {
                plugins: {
                    legend: {
                        display: false
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef'
                        }
                    },
                    y: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef'
                        }
                    }
                }
            },
            chartData: {
            labels: [],	      
            datasets: [
              {
                  data: [],
                  backgroundColor: [],
              }
            	]
            },
            lightOptions: {
            plugins: {
                legend: {
                    labels: {
                        color: '#495057'
                    }
                }
            }
            },
    }
  },
  mounted()
  {
  	this.getData()
  },
  computed:{
    narrow()
    {
        
    },
    preflang_id()
    {
        return this.$store.state.auth.user.preflang_id
    },
    name_area()
    {
        if(this.is_narrow)
        {
            return "col-12"
        }
        return "col-12 md:col-3 pl-3"
    },

    project_info()
    {
        if(this.is_narrow)
        {
            return "col-7"
        }
        return "col-12"
    },
    project_button()
    {
        if(this.is_narrow)
        {
            return "col-5 mt-3"
        }
        return "col-12"
    },
    line_graph_area()
    {
        if(this.is_narrow)
        {
            return "col-12 md:col-8"
        }
        return "col-12 md:col-6"
    },
    pie_graph_area()
    {
        if(this.is_narrow)
        {
            return "col-12 md:col-4"
        }
        return "col-12 md:col-3"
    },
  	projectname()
  	{
        return this.getTheTranslation(this.data.project,"translation")
  		
  		
  	}
  },
  watch:{
    preflang_id()
    {
        setTimeout(()=>{
            this.lineChartData.datasets[0].label =this.$store.state.languages.lang_phrases.tamamlanma_araligi
            this.resolveProjectSuppliersPieChart()
        },500)
        
    }
  },
  methods:{
    gotoProject()
    {
        this.$router.push({ name: 'Project', params: { id:this.data.project.id } })
    },
  	async getData()
  	{
  		this.loading = await true
  		let data = await this.generalApiGetWithoutLoader("brand_project_suppliers/"+this.project_id)
  		
  		this.data = await data
  		await this.resolveProjectSuppliersPieChart()
  		await this.resolveProjectSuppliersLineChart()
  		this.loading = await false
  	},
  	resolveProjectSuppliersLineChart()
  	{
  		let project = this.data.project

  		let start = moment(project.start_date)
  		let today = moment()
  		
  		let difff = today.diff(start, 'days')
  		let duration_chunk
  		
  		if(difff<=6)
  		{
  			duration_chunk = 1
  		}
  		else if(difff>60)
  		{
  			duration_chunk = 30
  		}
  		else if(difff>45)
  		{
  			duration_chunk = 15
  		}
  		else
  		{
  			duration_chunk = 7
  		}

  		let finished_project = this.data.project_suppliers.filter((item)=>{return item.status == "finished"})

  		let days_addition = 0
  		while(difff>0)
  		{
  			let start = moment(project.start_date).add(days_addition,'days')
  			let end = start.add(duration_chunk,'days')
  			

  			let fitting_suppliers = this.data.project_suppliers.filter((item)=>{
  				let updated_at = moment(item.updated_at)  				
  				if(start >= updated_at && updated_at <= end && item.status =="finished")
  				{   							
  					return item
  				}  				
  			})

  			

  			this.lineChartData.labels.push(start.format("DD-MM-YYYY"))
  			this.lineChartData.datasets[0].data.push(fitting_suppliers.length)

  			difff = difff-duration_chunk
  			days_addition = days_addition+duration_chunk
  		}






  	},
  	resolveProjectSuppliersPieChart()
  	{
  		let projectsuppliers = this.data.project_suppliers
        this.chartData.datasets[0].data = []
        this.chartData.labels = []
        this.chartData.datasets[0].data = []
        this.started = 0
        this.finished = 0
        
  		for(let item of projectsuppliers)
  		{   
  			let status = item.status
  			this[status]++
  		}
  		if(this.started>0)
		{
			this.chartData.labels.push(this.$store.state.languages.lang_phrases.baslandi)
			this.chartData.datasets[0].data.push(this.started)
			this.chartData.datasets[0].backgroundColor.push("#dd4b39")
		}
		if(this.finished>0)
		{
			this.chartData.labels.push(this.$store.state.languages.lang_phrases.tamamlandi0)
			this.chartData.datasets[0].data.push(this.finished)
			this.chartData.datasets[0].backgroundColor.push("#4dc247")
		}
  	}
  },
}
</script>

<style lang="css" scoped>
</style>